import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import $, { get } from 'jquery';
import Modal from "react-modal";
import { withRouter } from '../utils/withRouter';

const ConfirmationModal = (props) => {
    const handleClick = (flag) => {
        console.log(props)
        props.onConfirmation(flag);
    };

    return (
        <>
            <Modal isOpen={true} >
                <div className="modal-dialog">
                    <div className="modal-content confirm-logout">
                        <div class="modal-header text-right p-2">
                            <h5 class="modal-title modal_title_text text-Primary">{props.message.message}</h5>
                        </div>
                        {/* <div class="modal-body">
                            <div class="row">
                            </div>
                        </div> */}
                        <div class="modal-footer p-1">
                            <div class="form-group text-right mod-fot">
                                <button type="button" className="btn btn-aqua btn-sm"
                                    onClick={() => handleClick(1)}
                                >{props.message.buttonName}</button>
                                <button type="button" className="btn btn-gray btn-sm" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                    onClick={() => handleClick(0)}
                                >Close</button>
                            </div>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
}

export default ConfirmationModal;